import { th, vi, en, ja, ptBR, es } from "date-fns/locale";
import UIen from "element-ui/lib/locale/lang/en";
import UIja from "element-ui/lib/locale/lang/ja";
import UIth from "element-ui/lib/locale/lang/th";
import UIvi from "element-ui/lib/locale/lang/vi";
import UIptBr from "element-ui/lib/locale/lang/pt-br";
import UIes from "element-ui/lib/locale/lang/es";

import Axios from "axios";

export const locale_lang = [
  { id: "en", label: "English", country_code: "us" },
  { id: "ja", label: "日本語", country_code: "jp" },
  // { id: "th", label: "Thailand", country_code: "th" },
  // { id: "vi", label: "Tiếng Việt", country_code: "vn" },
  // { id: "pt-br", label: "Português", country_code: "br" },
  // { id: "es-mx", label: "Español", country_code: "es" },
];

export const locale_mapping_date = {
  th: th,
  vi: vi,
  en: en,
  ja: ja,
  "pt-br": ptBR,
  "es-mx": es,
};

export const locale_mapping_UI = {
  th: UIth,
  vi: UIvi,
  en: UIen,
  ja: UIja,
  "pt-br": UIptBr,
  "es-mx": UIes,
};

// load native languages from Speak app
const languages_url = process.env.VUE_APP_ELSA_SPEAK_APP_URL + "languages";
export function getNativeLanguages() {
  return Axios.get(
    languages_url,
  ).then((res) => {
    return res.data.map((lang) => {
      return {
        label: lang.language,
        value: lang.language_code,
      };
    });
  })
  .catch((err) => {
    throw new Error("Failed to fetch native languages from Speak app");
  });
}
